import app from '@/firebase'
import { queryClient } from '@/integrations/react-query'
import { getDatabase, onValue, ref } from 'firebase/database'
import { useEffect, useRef } from 'react'

// Listens for the backend signal that a cabas estimate finished syncing and
// invalidates the scenarios cache so the Cases page refetches automatically.
export const useCabasSyncListener = () => {
  const lastSyncedAt = useRef<number | null>(null)

  useEffect(() => {
    const db = getDatabase(app)
    const syncRef = ref(db, 'cabasEstimates/lastSyncedAt')

    return onValue(syncRef, (snapshot) => {
      const value: number | null = snapshot.val()

      if (lastSyncedAt.current === null) {
        lastSyncedAt.current = value ?? 0
        return
      }

      if (value !== null && value > lastSyncedAt.current) {
        lastSyncedAt.current = value
        queryClient.invalidateQueries({ queryKey: ['scenarios'] })
      }
    })
  }, [])
}
